export default __webpack_public_path__ + "static/media/coinbase.7472806f.svg";